import {PushNotifications} from '@capacitor/push-notifications';
import router, {ROUTE_NAMES} from "@/router";

export const checkPermissions = async () => {

    let permStatus = await PushNotifications.checkPermissions();
    return permStatus.receive === 'granted'

};

export const requestPermissions = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions!');
    }

    await PushNotifications.register();
};


export const deleteToken = async () => {
    await PushNotifications.unregister()
};

export const removeAllDeliveredNotifications = async () => {
    // await PushNotifications.removeAllDeliveredNotifications();
};

const addListeners = async () => {
    console.log('Adding listeners');
    await PushNotifications.addListener('registration', token => {
        console.info('Registration token: ', token.value);
    });

    await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log('Push notification action performed', notification.actionId, notification.inputValue);
        router.push({name: ROUTE_NAMES.ORDERS_VIEW});
    });
}

export default async app => {

    try {

        await addListeners()

    } catch (e) {

    }


}